<script setup lang="ts">
  // Table content
  const footerTypes = [
    {
      displayOption: 'Blank (default)',
      jsonValue: 'null',
      description: 'Nothing'
    },
    {
      displayOption: 'Listing',
      jsonValue: 'Listing',
      description: 'Lists the source file name where individual values were obtained.'
    },
    {
      displayOption: 'Calculated',
      jsonValue: 'Calculated',
      description: 'Lists the file with calculated values such as summaries.'
    },
    {
      displayOption: 'Date/Time',
      jsonValue: 'DateTime',
      description: 'Lists the date and time the table was created.'
    }
  ]
</script>
<template>
  <div style="max-height: 550px; overflow-y: auto">
    <table class="popover-table">
      <thead>
        <tr>
          <th>Display Option</th>
          <th>JSON Value</th>
          <th>Description</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in footerTypes" :key="row.displayOption">
          <td>{{ row.displayOption }}</td>
          <td>
            <code>{{ row.jsonValue }}</code>
          </td>
          <td>
            {{ row.description }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped>
  .popover-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
  }
  .popover-table th,
  .popover-table td {
    border: 1px solid #ddd;
    padding: 6px 10px;
    text-align: left;
  }
  .popover-table th {
    background-color: #f5f5f5;
    font-weight: 600;
  }
  code {
    background-color: #f0f0f0;
    padding: 2px 4px;
    border-radius: 4px;
  }
</style>
